// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-total-onboardings-table {
  height: 100%;
  display: block;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-details/total-onboardings/details-table/fi-total-onboardings-table.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,cAAA;AACJ","sourcesContent":[".fi-total-onboardings-table {\r\n    height: 100%;\r\n    display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
